<template>
  <CCardHeader class="pageHeader d-flex flex-column justify-content-between py-5 px-0 bg-transparent">
    <div>
      <h1 class="pageHeader__title font-weight-normal mb-4">
        {{ $t(`backoffice.manage.balance.header.${title}`) }}
      </h1>
    </div>
    <div>
      <router-link :to="{ name: pathName }" class="text-decoration-none text-uppercase d-flex align-items-center text-gray-600">
        <CIcon name="arrow" :height="17" class="icon__rotateLeft mr-3" viewBox="0 0 32 32" />
        {{ $t(`general.${TextPathName}`) }}
      </router-link>
    </div>
  </CCardHeader>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    pathName: {
      type: String,
      required: true,
    },
    TextPathName: {
      type: String,
      required: true,
    },
  },
}
</script>

<style></style>
